export function normalizeComment(inputComment: string, show: boolean): string {
    if(inputComment.length <= 100) return inputComment
    else return inputComment.slice(0, show ?  inputComment.length : 20) + (show ? "" : "\u2026")
}